import { render, staticRenderFns } from "./PubDetailContentSubsection.vue?vue&type=template&id=fb878fe2&scoped=true"
import script from "./PubDetailContentSubsection.vue?vue&type=script&lang=js"
export * from "./PubDetailContentSubsection.vue?vue&type=script&lang=js"
import style0 from "./PubDetailContentSubsection.vue?vue&type=style&index=0&id=fb878fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb878fe2",
  null
  
)

export default component.exports